<template>
  <div>
    <b-row class="row-align-left">
      <b-col sm="7">
        <label for="radios12">
          Would you like to be contacted to learn more about the diabetes prevention/self- management education classes available in Palm Beach County?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': contactForDiabetesPreventionState }"
                name="rd10"
                value="true"
                v-model="$v.contactForDiabetesPrevention.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': contactForDiabetesPreventionState }"
                name="rd10"
                value="false"
                v-model="$v.contactForDiabetesPrevention.$model"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row class="row-align-left">
      <b-col sm="7">
        <label for="radios9">
          Do you have a primary care doctor or use primary care clinic services for your
          medical care?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': havePrimaryDoctorState }"
                name="rd8"
                value="true"
                v-model="$v.havePrimaryDoctor.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': havePrimaryDoctorState }"
                name="rd8"
                value="false"
                v-model="$v.havePrimaryDoctor.$model"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row class="row-align-left">
      <b-col sm="7">
        <label for="radios10">
          Will you follow up with your medical provider once you have the
          results of this screening?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': followUpResultsState }"
                name="rd9"
                value="true"
                v-model="$v.followUpResults.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': followUpResultsState }"
                name="rd9"
                value="false"
                v-model="$v.followUpResults.$model"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <hr>
    <b-row class="row-align-left">
      <b-col sm="5">
        <label for="txtFirstAndLastName">First and Last Name:</label>
          <b-form-input
          id="txtFirstAndLastName"
          placeholder="name"
          v-model.trim="$v.firstAndLastName.$model"
          :state="firstAndLastNameState"
          size="lg"
        ></b-form-input>
      </b-col>
      <b-col sm="5">
        <label for="txtTelephoneNumber">Telephone Number:</label>
        <b-form-input
          id="txtTelephoneNumber"
          placeholder="phone"
          v-model.trim="$v.telephoneNumber.$model"
          :state="telephoneNumberState"
          size="lg"
        ></b-form-input>
      </b-col>
    </b-row>
    <hr>
    <b-row class="row-align-left">
      <b-col sm=5>
        <label for="txtEmail">Email:</label>
        <b-form-input
          id="txtEmail"
          placeholder="email"
          v-model.trim="$v.emailAddress.$model"
          :state="emailAddressState"
          size="lg"
        ></b-form-input>
      </b-col>
     
    </b-row> -->
    
    <survey-nav
      :step="7"
      :ShowErrorMsg="showErrorMsg"
      @move-next="moveNext"
      @move-previous="movePrevious"
    ></survey-nav>
  </div>
</template>

<script>
import surveyNav from "@/components/SurveyNav";
import { required } from "vuelidate/lib/validators";

export default {
  name: "survey-step2",
  props: ["surveyData", "isValid"],
  data: () => ({
    //emailAddress: null,
    contactForDiabetesPrevention: null,
    //contactForHealthCoverage: null,
    followUpResults: null,
    havePrimaryDoctor: null,
    // telephoneNumber: null,
    // firstAndLastName: null,
    showErrorMsg: false
  }),
  validations: {
    contactForDiabetesPrevention: {
      required
    },
    havePrimaryDoctor: {
      required
    },
    followUpResults: {
      required
    }  
    // firstAndLastName: {

    // },
    // telephoneNumber: {

    // },
    // emailAddress: {
      
    // }
  },
  components: {
    surveyNav
  },
  methods: {
    moveNext() {      
     if (this.validateForm()) {
        this.$emit("move-next");
      } else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }
    },
    movePrevious() {
      this.$emit("move-previous");
    },
    onCreated() {
      //load the data from the survey into the form
      //this.contactForHealthCoverage = this.surveyData.ContactForHealthCoverage;
      this.contactForDiabetesPrevention = this.surveyData.ContactForDiabetesPrevention;
      this.followUpResults = this.surveyData.FollowUpResults;
      this.havePrimaryDoctor = this.surveyData.HavePrimaryDoctor;
      // this.firstAndLastName = this.surveyData.FirstAndLastName;
      // this.telephoneNumber = this.surveyData.TelephoneNumber;
      // this.emailAddress = this.surveyData.EmailAddress;
    },
    // validateTelNumber() {
    //  if (this.contactForHealthCoverage === "1"  || this.contactForDiabetesPrevention === "true")
    //   {
    //     if (this.telephoneNumber) return true; //We have phone, we are valid
    //     if(this.emailAddress) return null; //We have an email address, therefore phone is optional        
    //     return false;
    //   }
    //   else return null;
    // },
    // validateEmail() {
    //   if (this.contactForHealthCoverage === "1"  || this.contactForDiabetesPrevention === "true")
    //   {
    //     if (this.emailAddress) return true; //We have and email, we are valid
    //     if (this.telephoneNumber){ return null; }; //We have a phone, therefore, email is optional        
    //     return false;
    //   }
    //   else return null;
    // },
    validateForm() {
      if(this.$v.$invalid) return false;
      if (this.contactForHealthCoverage === "1"  || this.contactForDiabetesPrevention === "true"){
        if(this.firstAndLastName === '') return false;
        if(this.telephoneNumber === '' && this.emailAddress === '') return false;
      }
      return true;
    }
  },
  computed: {
    // contactForHealthCoverageState() {
    //   return this.$v.contactForHealthCoverage.$dirty
    //     ? !this.$v.contactForHealthCoverage.required
    //     : null;
    // },
    contactForDiabetesPreventionState() {
      return this.$v.contactForDiabetesPrevention.$dirty
        ? !this.$v.contactForDiabetesPrevention.required
        : null;
    },
    followUpResultsState() {
      return this.$v.followUpResults.$dirty
        ? !this.$v.followUpResults.required
        : null;
    },
    havePrimaryDoctorState() {
      return this.$v.havePrimaryDoctor.$dirty
        ? !this.$v.havePrimaryDoctor.required
        : null;
    }
    // firstAndLastNameState() {
    //   if (this.contactForHealthCoverage === "1"  || this.contactForDiabetesPrevention === "true")
    //   {
    //     if (!this.firstAndLastName) return false;
    //     return true;
    //   }
    //   else 
    //     {
    //       console.log("firstAndLastNameState: return null");
    //       return null
    //       };
    // },
    // telephoneNumberState() {
    //   return this.validateTelNumber();
    // },
    // emailAddressState() {
    //   return this.validateEmail();
    // }
  },
  watch: {
    followUpResults() {
      if (this.$v.followUpResults.required)
        this.surveyData.FollowUpResults = this.followUpResults == "true";
    },
    havePrimaryDoctor() {
      if (this.$v.havePrimaryDoctor.required)
        this.surveyData.HavePrimaryDoctor = this.havePrimaryDoctor == "true";
    },
    // contactForHealthCoverage() {
    //   if (this.$v.contactForHealthCoverage.required)
    //     this.surveyData.ContactForHealthCoverage = this.contactForHealthCoverage;
    // },
    contactForDiabetesPrevention() {
      if (this.$v.contactForDiabetesPrevention.required)
        this.surveyData.ContactForDiabetesPrevention = (this.contactForDiabetesPrevention == 'true');
    },
    // firstAndLastName() {
    //   if (this.$v.firstAndLastName)
    //     this.surveyData.FirstAndLastName = this.firstAndLastName;
    // },
    // telephoneNumber() {
    //   if (this.$v.telephoneNumber)
    //     this.surveyData.TelephoneNumber = this.telephoneNumber;
    // },
    // emailAddress() {
    //   if (this.$v.emailAddress)
    //     this.surveyData.EmailAddress = this.emailAddress;
    // }
  },
  created() {
    this.onCreated();
  }
};
</script>
